<template>
  <div
    v-tooltip="'Filter by favorite'"
    class="cursor-pointer"
    @click="$emit('change', !selected)"
  >
    <lm-icon
      icon="starList"
      class="hover:text-black"
      :class="{'text-highlight': selected}"
    />
  </div>
</template>

<script>
import LmIcon from '@/components/ui/LmIcon'
export default {
  name: 'FavoriteList',
  components: {LmIcon},
  props: {
    selected: {
      type: Boolean,
      required: true
    }
  }
}
</script>
